import { createFileRoute } from "@tanstack/react-router"
import { OrganizationLayout } from "@/components"

export const Route = createFileRoute("/_authenticated/_organization")({
  component: OrganizationLayout,
})
